export default __webpack_public_path__ + "static/media/teeth.2c407244.svg";